module.exports = __webpack_public_path__ + "static/logo-dc68b7e3d9c65c12815e91cd1dc7078c.png";